// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iEDBkqDkKx4tNf3yqzW_{align-items:center;gap:8px;display:flex}.iEDBkqDkKx4tNf3yqzW_ .OeTD2XILDOADLKEmsYi3{border:1px solid var(--black-20);background-position:50%;background-repeat:no-repeat;background-size:cover;border-radius:100%;justify-content:center;align-items:center;width:48px;height:48px;display:flex}.iEDBkqDkKx4tNf3yqzW_ .OeTD2XILDOADLKEmsYi3.IO9RJjt39QYClzoiDLvK{border-radius:6px}.iEDBkqDkKx4tNf3yqzW_ .y6_QzM17txYSIVukz5EN{max-width:300px;margin-top:4px;display:block}.JdNYPYEe5kwF4FUSWNQQ{flex-direction:column;padding:0 0 2px 4px;display:flex}.SgbstbTvoO0i3gth0Wkn{height:-webkit-max-content;height:max-content}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoWrap": `iEDBkqDkKx4tNf3yqzW_`,
	"logo": `OeTD2XILDOADLKEmsYi3`,
	"square": `IO9RJjt39QYClzoiDLvK`,
	"logoSubtitle": `y6_QzM17txYSIVukz5EN`,
	"labelWrap": `JdNYPYEe5kwF4FUSWNQQ`,
	"uploadButton": `SgbstbTvoO0i3gth0Wkn`
};
export default ___CSS_LOADER_EXPORT___;
